import {LoadMoreComponent} from './load.more.component';

export const LOAD_MORE_COMPONENTS = [
    LoadMoreComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/load-more/index.ts